<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none" label="学年">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refreshAll"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none" label="学期">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refreshAll"
          ></school-term-selector>
        </el-form-item>
        <div class="space"></div>
      </div>
    </el-form>
    <div style="background-color: white">
      <el-row style="max-width: 1000px; margin: 0 auto">
        <el-col :span="12">
          <div class="chart-box">
            <div class="box">
              <echarts :option="option1"></echarts>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-box">
            <div class="box">
              <echarts :option="option2"></echarts>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="filter-bar table-head mb-2px" type="flex">
      <el-form :model="filterForm"
        ><div class="filter-bar" type="flex">
          <el-form-item class="mb-none">
            <el-input
              size="small"
              v-model="filterForm.keyword"
              clearable
              placeholder="搜索教师姓名"
              style="width: 250px"
              @keydown.enter="refresh"
              @change="refresh"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item class="mb-none">
            <el-select
              size="small"
              v-model="filterForm.taskType"
              clearable
              placeholder="全部任务类型"
              class="ml-md"
              @change="refresh"
            >
              <el-option
                v-for="item in typeListOption"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mb-none">
            <el-select
              size="small"
              v-model="filterForm.taskStatus"
              clearable
              placeholder="全部状态"
              class="ml-md"
              @change="refresh"
            >
              <el-option
                v-for="item in statusOption"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="fr">
        <el-button
          v-if="power(userInfo.menuInfoList, 'task-pub-export')"
          type="primary"
          class="el-icon-upload2"
          size="small"
          @click="toExport"
          >导出</el-button
        >
        <el-button
          v-if="power(userInfo.menuInfoList, 'task-add')"
          type="primary"
          class="el-icon-plus"
          size="small"
          @click="onAdd"
          >新增</el-button
        >
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="schoolYear" label="学年" align="center">
      </el-table-column>
      <el-table-column
        prop="schoolTerm"
        label="学期"
        :formatter="schoolTermFormatter"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="teacherName"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="taskTypeDesc"
        label="任务类型"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="taskNum"
        label="要求数量"
        align="center"
      ></el-table-column
      ><el-table-column
        prop="completeNum"
        label="完成数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="startDate"
        label="开始时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="endDate"
        label="结束时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="taskStatus"
        label="状态"
        align="center"
        :formatter="
          (r, c, cellValue) =>
            statusOption.find((u) => u.code == cellValue).name || ''
        "
      ></el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            :disabled="
              !userInfo.roleCodes.includes('admin') &&
              userInfo.userId != scope.row.createBy
            "
            style="margin-right: 12px"
            @click="onEdit(scope.row)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              slot="reference"
              type="text"
              class="danger"
              size="small"
              :disabled="
                !userInfo.roleCodes.includes('admin') &&
                userInfo.userId != scope.row.createBy
              "
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="filterForm"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </el-table>
    <el-dialog
      title="新增任务"
      :visible.sync="dialogNewTask"
      @closed="onDialogNewTaskClose"
    >
      <el-form
        v-loading="saving"
        class="content-box"
        label-width="140px"
        ref="elNewTaskForm"
        :model="newTaskForm"
        :rules="rules"
      >
        <el-form-item label="任务名称" prop="taskName">
          <el-input
            maxlength="20"
            show-word-limit
            v-model="newTaskForm.taskName"
            placeholder="请输入任务名称"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolYear" label="学年">
              <school-year-selector
                v-model="newTaskForm.schoolYear"
              ></school-year-selector>
            </el-form-item>
          </el-col>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolTerm" label="学期">
              <school-term-selector
                :checkAll="false"
                v-model="newTaskForm.schoolTerm"
              ></school-term-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务类型" prop="taskType" size="small">
          <el-select v-model="newTaskForm.taskType">
            <el-option
              v-for="item in typeListOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起止日期" prop="dateTemp" size="small">
          <el-date-picker
            v-model="newTaskForm.dateTemp"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="任务数量" prop="taskNum">
          <el-input
            v-model="newTaskForm.taskNum"
            type="number"
            placeholder="请输入任务数量"
            min="0"
            max="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="教师" prop="teacherList" v-if="!isEdit">
          <el-button type="text" @click="addOtherUser">添加</el-button>
          <div class="scorll-list" v-if="newTaskForm.teacherList.length > 0">
            <el-tag
              @close="tagJoinRemove(tag.userId)"
              size="small"
              v-for="tag in newTaskForm.teacherList"
              :key="tag.id"
              closable
              >{{ tag.userName }}</el-tag
            >
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogNewTask = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <join-pop
      @close="closeJoinPop"
      @joinUsersChange="joinUserChange"
      :showJoinPop="showJoinPop"
    ></join-pop>
  </div>
</template>

<script>
import { power, fileSaveZip } from "@/utils/index.js";
import SchoolTermSelector from "../../components/school/schoolTermSelector.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import Echarts from "../../components/echarts.vue";
import JoinPop from "@/components/common/JoinPop.vue";
import { mapState, mapGetters } from "vuex";
import { postData, postJson } from "../../http/fetch";
import Pagination from "../../components/Pagination.vue";
const taskForm = {
  id: null,
  taskType: null,
  schoolTerm: null,
  schoolYear: null,
  dateTemp: null,
  teacherList: [],
  taskNum: null,
  taskStatus: null,
  taskName: null,
};
export default {
  components: {
    schoolYearSelector,
    SchoolTermSelector,
    Echarts,
    Pagination,
    JoinPop,
  },
  name: "taskPub",
  data() {
    return {
      statusOption: [
        {
          name: "未完成",
          code: 0,
        },
        {
          name: "进行中",
          code: 1,
        },
        {
          name: "已完成",
          code: 2,
        },
      ],
      pageLoading: false,
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: "",
        taskType: "",
        size: 10,
        current: 1,
        total: 0,
      },
      showJoinPop: false, //老师弹框
      dialogNewTask: false,
      pieData: [],
      LineData: [],
      typeListOption: [],
      tableData: [],
      saving: false,
      isEdit: false,
      newTaskForm: taskForm,
      rules: {
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        schoolTerm: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        taskType: [
          { required: true, message: "请选择任务类型", trigger: "change" },
        ],
        teacherTemp: [
          { required: true, message: "请选择申报人", trigger: "change" },
        ],
        dateTemp: [
          { required: true, message: "请选择任务日期", trigger: "change" },
        ],
        taskNum: [
          { required: true, message: "请输入任务数量", trigger: "change" },
        ],
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "change" },
        ],
        teacherList: [
          { required: true, message: "请选择教师", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode", "operatorId", "schoolCodes"]),
    option1() {
      return {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "10%",
        },
        color: [
          "#3AA0FF",
          "#36CBCB",
          "#4DCB73",
          "#FAD337",
          "#F2637B",
          "#975FE4",
          "#FFCB91",
          "#B5C347",
        ],
        series: [
          {
            label: {
              formatter: "{name|{b}  {c}}\n{time|{d} %}",
              minMargin: 5,
              edgeDistance: 10,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            type: "pie",
            radius: "50%",
            data: this.pieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    option2() {
      return {
        title: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              color: "#D9D9D9",
            },
            axisLabel: {
              fontFamily: "pfrgl",
              interval: 0,
            },
            axisTick: {
              alignWithLabel: true,
              color: "#D9D9D9",
            },
            axisLabel: {
              formatter: (value) => value + "月",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            splitArea: false,
            minInterval: 1,
          },
        ],
        dataset: {
          source: this.LineData,
        },
        series: this.LineData.slice(1).map(() => ({
          type: "line",
          smooth: true,
          seriesLayoutBy: "row",
          emphasis: { focus: "series" },
        })),
      };
    },
  },
  created() {
    this.getTaskTypeList();
    this.refreshAll();
  },
  methods: {
    power,
    getTaskTypeList() {
      postData("/taskPublish/getTaskTypeList", {
        schoolCode: this.schoolCode,
      }).then((res) => {
        this.typeListOption = res;
      });
    },
    onAdd() {
      this.isEdit = false;
      this.newTaskForm = taskForm;
      this.dialogNewTask = true;
    },
    onSave() {
      this.$refs.elNewTaskForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          const obj = {
            endDate: this.newTaskForm.dateTemp[1],
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            schoolTerm: this.newTaskForm.schoolTerm,
            schoolYear: this.newTaskForm.schoolYear,
            startDate: this.newTaskForm.dateTemp[0],
            taskNum: this.newTaskForm.taskNum,
            taskName: this.newTaskForm.taskName,
            taskType: this.newTaskForm.taskType,
            teacherList: this.newTaskForm.teacherList.map((m) => ({
              teacherId: m.userId,
              teacherName: m.userName,
            })),
          };
          if (this.isEdit) {
            obj.id = this.newTaskForm.id;
            postJson("/taskPublish/updateTeacherTaskPublish", obj)
              .then((res) => {
                this.dialogNewTask = false;
                this.$message.success("操作成功！");
                this.refresh();
              })
              .finally(() => {
                this.saving = false;
              });
          } else {
            postJson("/taskPublish/saveTeacherTaskPublish", obj)
              .then((res) => {
                this.dialogNewTask = false;
                this.$message.success("操作成功！");
                this.refresh();
              })
              .finally(() => {
                this.saving = false;
              });
          }
        }
      });
    },
    onEdit(row) {
      this.isEdit = true;
      this.newTaskForm = {
        id: row.id,
        schoolTerm: row.schoolTerm,
        schoolYear: row.schoolYear,
        taskType: row.taskType,
        taskNum: row.taskNum,
        taskName: row.taskName,
        dateTemp: [row.startDate, row.endDate],
        teacherList: [
          {
            userId: row.teacherId,
            userName: row.teacherName,
          },
        ],
      };
      this.dialogNewTask = true;
    },
    toExport() {
      this.$axios
        .post(
          "/taskPublish/exportTeacherTaskPublish",
          this.$qs.stringify({
            taskType: this.filterForm.taskType,
            keyword: this.filterForm.keyword,
            schoolTerm: this.filterForm.schoolTerm,
            schoolYear: this.filterForm.schoolYear,
            pageNum: this.filterForm.current,
            pageSize: this.filterForm.size,
            taskStatus: this.filterForm.taskStatus,
            schoolCode: this.schoolCode,
            operatorId: this.operatorId,
          }),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          this.pageLoading = false;
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    async getStaData() {
      this.loading = true;
      await postData("/taskPublish/getTaskPublishLine", {
        schoolCode: this.schoolCode,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
      }).then((res) => {
        this.LineData = res;
      });
      await postData("/taskPublish/getTaskPublishStatusPie", {
        schoolCode: this.schoolCode,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
      }).then((res) => {
        this.pieData = res;
      });
    },
    async refresh() {
      postJson("/taskPublish/getTeacherTaskPublishList", {
        taskType: this.filterForm.taskType,
        keyword: this.filterForm.keyword,
        schoolTerm: this.filterForm.schoolTerm,
        schoolYear: this.filterForm.schoolYear,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        taskStatus: this.filterForm.taskStatus,
        schoolCode: this.schoolCode,
        operatorId: this.operatorId,
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async refreshAll() {
      this.pageLoading = true;
      await this.refresh();
      await this.getStaData();
      this.$nextTick(() => {
        this.pageLoading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.refresh();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.refresh();
    },
    onDialogNewTaskClose() {
      this.$refs.elNewTaskForm.resetFields();
    },
    //添加指定教师
    addOtherUser() {
      this.showJoinPop = true;
    },
    //取消指定教师
    cancelOtherUser() {
      this.newTaskForm.teacherList = [];
    },
    //关闭添加主讲人弹框
    closeJoinPop() {
      this.showJoinPop = false;
    },
    //添加主讲教师
    joinUserChange(teacherList) {
      teacherList.forEach((i) => {
        if (
          !this.newTaskForm.teacherList
            .map((item) => item.userId)
            .includes(i.userId)
        ) {
          this.newTaskForm.teacherList.push(i);
        }
      });
    },
    //移除参与教师
    tagJoinRemove(userId) {
      this.newTaskForm.teacherList = this.newTaskForm.teacherList.filter(
        (i) => i.userId != userId
      );
    },
    schoolTermFormatter(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "上学期";
      } else if (cellValue == 2) {
        return "下学期";
      } else if (cellValue == 3) {
        return "全部";
      }
    },
    onDel(row) {
      this.saving = true;
      postJson("/taskPublish/deleteTeacherTaskPublish", {
        id: row.id,
        operatorId: this.operatorId,
      })
        .then((res) => {
          this.refresh();
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}
.chart-box {
  width: 100%;
  padding-bottom: 100%;
  height: 0;
  position: relative;
  overflow: hidden;
  .box {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
